// extracted by mini-css-extract-plugin
export default {"root":"_1fCpL","link-overlay":"d_a3J","linkOverlay":"d_a3J"};